"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PathContrastStroke = exports.PathPrimaryStroke = exports.PathPrimary = exports.PathContrast = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PathContrast = _styledComponents.default.path(_templateObject(), function (props) {
  return props.theme.colorPrimaryLight;
});

exports.PathContrast = PathContrast;

var PathPrimary = _styledComponents.default.path(_templateObject2(), function (props) {
  return props.theme.colorTextPrimary;
});

exports.PathPrimary = PathPrimary;

var PathPrimaryStroke = _styledComponents.default.path(_templateObject3(), function (props) {
  return props.theme.colorTextPrimary;
});

exports.PathPrimaryStroke = PathPrimaryStroke;

var PathContrastStroke = _styledComponents.default.path(_templateObject4(), function (props) {
  return props.theme.colorPrimaryLight;
});

exports.PathContrastStroke = PathContrastStroke;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Icon/IconFormatting.js